import { proxy, snapshot, useSnapshot } from "@web-monorepo/hooks";
import { RandomPayload, RandomState, inflateRandomPayload, initialRandomState } from ".";

const store = proxy<RandomState>({ ...initialRandomState });

export const toolkitRandomActions = {
  receiveRandom(payload: RandomPayload) {
    const { students, student } = inflateRandomPayload(payload);
    store.student = student;
    store.students = students;

    if (store.previouslyChosenStudents.length >= students.length) {
      store.previouslyChosenStudents = [student];
    } else {
      // In May 2026, based on how toolkit is wired up with NATS, we observed the same payload being
      // received/processed twice. That caused the student to be added to previouslyChosenStudents
      // twice, ultimately resulting in the length check above to be triggered early, resetting the state
      // and allowing previously chosen students to be chosen again before all students had been chosen.
      // As a simple defensive guard, we only add the student to the previously chosen students list
      // if it's not already there.
      if (!store.previouslyChosenStudents.some((ps) => ps._id === student._id)) {
        store.previouslyChosenStudents = store.previouslyChosenStudents.concat(student);
      }
    }
  },
};

export function useToolkitRandomStore() {
  return useSnapshot(store);
}

export function getToolkitRandomState() {
  return snapshot(store);
}

export function resetToolkitRandomStore() {
  Object.assign(store, initialRandomState);
}
